module.exports = __webpack_public_path__ + "static/media/importICloud3.33d2b366.png";